<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .card {
    border: 1px solid colors.get(interfaceSwGrey_10);
    border-radius: utils.in_rem(16px);
    padding: utils.in_rem(12px);
    min-width: utils.in_rem(268px);
    flex: 1;
    display: flex;
    flex-direction: column;

    .usage {
      @include mixins.h5();
      text-align: right;
      margin-bottom: utils.in_rem(8px);
    }

    .status-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }

    &.external {
      background: colors.get(interfaceSwGrey_5);
    }
    &.internal {
      &.inactive {
        background: colors.get(interfaceSwGrey_10);
      }
    }
  }
</style>

<script>
  import LicenseCardHeader from "./Components/LicenseCardHeader.svelte";
  import ProgressBar from "./Components/ProgressBar.svelte";
  import Skeleton from "./Components/Skeleton.svelte";
  import TeamStatus from "./Components/TeamStatus.svelte";
  import UserStatus from "./Components/UserStatus.svelte";

  let {
    licenseInfo,
    skeleton,
    type = "internal",
    permissionLevel = "user",
    onclick,
  } = $props();

  let title = $derived(licenseInfo.title);
  let activeCount = $derived(licenseInfo.activeCount);
  let total = $derived(licenseInfo.total);
  let status = $derived(licenseInfo.total > 0 ? "active" : "inactive");
  let hasNoLicenses = $derived(total === 0);
</script>

{#if skeleton}
  <Skeleton />
{:else}
  <div class="card {type} {status}">
    <LicenseCardHeader {title} {status} {onclick} {hasNoLicenses} />
    <div class="status-container">
      {#if permissionLevel === "team"}
        <TeamStatus {status} />
      {:else}
        <UserStatus {activeCount} {total} {type} {skeleton} {status} />
      {/if}
      {#if !hasNoLicenses && permissionLevel === "user"}
        <ProgressBar {activeCount} {total} {type} {status} />
      {/if}
    </div>
  </div>
{/if}
